module.exports = __webpack_public_path__ + "img/middey-logowhitebg.7893c61c.png";